module.exports = __webpack_public_path__ + "12f773bf86cab16d3e4b23deb121fba5.pdf";